
import {
    Box,
    Container,
    Typography,
    Grid,
} from '@mui/material'; 
import { motion } from 'framer-motion';
import { styled } from '@mui/system';
import { useTenantConfig } from '../hooks/useTenant';

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

const TRUST_ITEMS = [
    { img: '/assets/icon/dashboard.webp', title: 'Panelden Kontrol', desc: 'Tüm içerikler tek yönetim panelinden oluşturulur ve yönetilir.' },
    { img: '/assets/icon/instant-message.webp', title: 'Anlık Yansıma', desc: 'Panelde yapılan her değişiklik web sitesine otomatik yansır.' },
    { img: '/assets/icon/test.webp', title: 'Mobil Uyumlu', desc: 'Tüm cihazlarda responsive ve akıcı görünüm sağlanır.' },
    { img: '/assets/icon/seo.webp', title: 'SEO Uyumlu', desc: 'Sayfa yapısı arama motorları için optimize edilmiştir.' },
    { img: '/assets/icon/shield.webp', title: 'Güvenli Bağış', desc: 'Bağış işlemleri şifreli ve güvenli altyapı üzerine çalışır.' },
];


const SectionBadge = styled(motion.div)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 20px',
    borderRadius: 50,
    background: 'rgba(30, 64, 175, 0.06)',
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(30, 64, 175, 0.12)',
    boxShadow: '0 2px 12px rgba(30, 64, 175, 0.08)',
    marginBottom: 20,
});


export const EndSection = () => {
    const {colors} = useTenantConfig();
    return (
        <Box sx={{
            py: { xs: 8, md: 12 },
            background: 'linear-gradient(325deg, rgba(239, 246, 255, 0.5) 0%, #f8fafc 50%, #ffffff 100%)',
            borderTop: '1px solid #e5e7eb',
        }}>
            <Container maxWidth="lg">
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    <Box textAlign="center" mb={{ xs: 5, md: 7 }}>

                        <SectionBadge>
                            <Box
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: '#0891b2',
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: '0.8rem',
                                    fontWeight: 600,
                                    color: '#0891b2',
                                    letterSpacing: '0.5px',
                                }}
                            >
                                 DİJİTAL DERNEK YÖNETİMİ
                            </Typography>
                        </SectionBadge>

                        <Typography variant="h2"
                            sx={{
                                fontWeight: 800,
                                fontSize: { xs: '2.4rem', md: '2.5rem' },
                                color: '#0f172a',
                                mb: 2,
                                letterSpacing: '-0.02em',
                                lineHeight: 1.2,
                            }}>
                         Dernek Yönetimi İçin
                         <br/>
                          Modern Bir Sistem
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                maxWidth: 760,
                                mx: 'auto',
                                fontSize: { xs: '1rem', md: '1.15rem' },
                                color: '#64748b',
                                lineHeight: 1.75,
                                fontWeight: 500,
                            }}
                        >
                            SüperDernek ile her şey hızlı, düzenli ve kontrol altında.
                        </Typography>
                    </Box>

                    {/* Grid Kartlar */}
                    <Grid container spacing={3}>
                        {TRUST_ITEMS.map((item, i) => (
                            <Grid item xs={12} sm={6} md={2.4} key={i}>
                                <motion.div
                                    variants={fadeUp}
                                    custom={i}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true }}
                                    style={{ height: '100%' }}
                                >
                                    <Box
                                        sx={{
                                            p: 3,
                                            borderRadius: 2.5,
                                            height: '100%',
                                            background: '#ffffff',
                                            border: '1px solid rgba(30, 64, 175, 0.12)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 2,
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                                            '&:hover': {
                                                background: '#ffffff',
                                                borderColor: colors.primary,
                                                boxShadow: `0 8px 24px rgba(30, 64, 175, 0.12)`,
                                                transform: 'translateY(-4px)',
                                                '& .trust-icon-box': {
                                                    transform: 'scale(1.08)',
                                                },
                                            },
                                        }}
                                    >
                                        <Box className="trust-icon-box" sx={{
                                            width: 64,
                                            height: 64,
                                            flexShrink: 0,
                                            borderRadius: 2,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: `linear-gradient(135deg, #0891b2 0%, #22d3ee 100%)`,
                                            transition: 'transform 0.3s ease',
                                        }}>
                                            <Box
                                                component="img"
                                                src={item.img}
                                                alt={item.title}
                                                className="trust-icon"
                                                sx={{
                                                    width: 38,
                                                    height: 38,
                                                    objectFit: 'contain',
                                                    filter: 'brightness(0) invert(1)',
                                                }}
                                            />
                                        </Box>
                                        <Typography sx={{
                                            fontSize: '0.9rem',
                                            fontWeight: 700,
                                            color: '#0f172a',
                                            textAlign: 'center',
                                            lineHeight: 1.35,
                                        }}>
                                            {item.title}
                                        </Typography>
                                        <Typography sx={{
                                            fontSize: '0.8rem',
                                            fontWeight: 400,
                                            color: '#64748b',
                                            textAlign: 'center',
                                            lineHeight: 1.5,
                                        }}>
                                            {item.desc}
                                        </Typography>
                                    </Box>
                                </motion.div>
                            </Grid>
                        ))}
                    </Grid>
                </motion.div>
            </Container>
        </Box>
    )
}
